import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Reminder } from 'app/models/dto/reminder.model';
import { ApiHttpClient } from 'app/http/clients/api';
import { NewReminderForm } from 'app/models/dto/new-reminder.model';
import { endOfDay, startOfDay } from 'date-fns';

@Injectable({
  providedIn: 'root'
})
export class ReminderService {
  constructor(
    private api: ApiHttpClient
  ) { }

  remindersToday(): Observable<Reminder[]> {
    return this.api.get<Reminder[]>('/reminder', {
      params: {
        query: JSON.stringify({
          criteria: {
            'expires': { '>': startOfDay(new Date(Date.now())) },
            'reminders.expires': { '<': endOfDay(new Date(Date.now())) },
            'reminders.deleted': { '=': null },
          }
        })
      }
    });
  }

  allReminders(): Observable<Reminder[]> {
    return this.api.get<Reminder[]>('/reminder', {
      params: {
        query: JSON.stringify({
          criteria: {
            'reminders.deleted': { '=': null }
          }
        })
      }
    });
  }

  create(newReminder: NewReminderForm): Observable<Reminder> {
    return this.api.post<Reminder>('/reminder', newReminder);
  }

  update(reminderId: number, updates: any): Observable<Reminder> {
    return this.api.put<Reminder>(`/reminder/${reminderId}`, updates);
  }

  delete(reminderId: number): Observable<Reminder[]> {
    return this.api.delete<Reminder[]>(`/reminder/${reminderId}`);
  }
}
